import { useTranslation } from 'next-i18next'
import React from 'react'

import { skillLabels } from '../../../functions/skillLabels'
import { useFeedbackStore } from '../../../functions/store'
import RatingLabel from '../ratingLabel'
import { AreaTitle } from './areaTitle'
import RatingField from './ratingField'

const PersonalSkills = ({ fighter, index }) => {
  const store = useFeedbackStore((state) => state)
  const { assignStar } = store.feedbackActions
  const { t } = useTranslation('avaliacao360')

  // Getting the GameSkills keys and current points for the current fighter
  const personalSkillsList = store.ratings[index].personalSkills

  const ratingHandler = (e) => {
    const { name, value } = e.target
    const numberValue = parseInt(value)
    assignStar(fighter, name, numberValue)
  }
  // console.log({ store })
  // console.log({ fighter, personalSkillsList })

  return (
    <div className="w-full mb-8 group bg-white p-3 md:p-4 rounded-xl">
      <AreaTitle title={t('personalSkills.title')} />
      <div className="grid grid-cols-2 w-full lg:grid-cols-3 -mt-4">
        {Object.entries(personalSkillsList).map(([skill, points]) => (
          <div key={skill} className="text-center border-b-1 border-slate-200">
            <RatingLabel text={t(`personalSkills.${skillLabels(skill)}`)} />
            <RatingField
              skill={skill}
              points={points}
              ratingHandler={ratingHandler}
            />
          </div>
        ))}
      </div>
    </div>
  )
}

export default PersonalSkills
